module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaDerecha-838bef1d.png";